import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

const BackButton = (props) => {
  const { goBack } = useHistory();

  const handleBack = () => {
    goBack();
  };

  return (
    <Button
      id="back-button"
      fullWidth={props.fullWidth}
      className="backButton"
      variant="contained"
      onClick={handleBack}
    >
      Back
    </Button>
  );
};

BackButton.propTypes = {
  fullWidth: PropTypes.bool,
};

export default BackButton;
